export default function parseHTML(content) {
  return content.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
}
